module.exports = __webpack_public_path__ + "media/images/help/header_02-14e2583632173db7dcf143ef8c9a33e0.png";